const InterviewStatus = {
  SCHEDULED: 'Scheduled',
  CONFIRMED: 'Confirmed',
  WRITER_CANCELLED: 'Cancelled by Writer',
  CUSTOMER_CANCELLED: 'Cancelled by Customer',
  EDITOR_CANCELLED: 'Cancelled by Editor',
  ADMIN_CANCELLED: 'Cancelled by Admin',
  COMPLETED: 'Completed',
  NO_SHOW: 'No show',
};

module.exports = InterviewStatus;
